import React from 'react'

import './Badge.scss';

interface BadgeProps {
  counter: number
  top?: number
  left?: number
  background?: string
  lineHeight?: number
}

const Badge = (props: BadgeProps) => {

  const {counter} = props

  const top = props.top || -5;
  const left = props.left || 24;
  const background = props.background || '#fe3a68';
  const lineHeight = props.lineHeight || 20;

  return (
    <div className={'badge ' + (counter <= 0 ? 'badge-hidden' : '')} style={{top: top+'px', left: left + 'px', background, lineHeight: lineHeight + 'px'}}>{counter}</div>
  )
}

export default Badge